import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setLogout } from "state";
import Layout from "components/Layout";
import ConfirmDialog from "components/ConfirmDialog";
import api from "utils/api";
import ProfileSettings, { PasswordSettings } from "./ProfileSettings";
import CookieSettings from "./CookieSettings";
import { APP_BRAND } from "utils/brand";
import { queueAuthSuccessPopup } from "utils/authSuccessPopup";
import "styles/konto.css";

const KontoPage = () => {
  const user = useSelector((s) => s.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(setLogout());
    queueAuthSuccessPopup("logout");
    navigate("/");
  };

  const [logoutOpen, setLogoutOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState(null);

  const confirmDeleteAccount = async () => {
    setDeleting(true);
    setDeleteMsg(null);
    try {
      const { data } = await api.post("/auth/request-account-deletion", {
        brand: APP_BRAND,
      });
      setDeleteOpen(false);
      setDeleteMsg({
        kind: "success",
        text:
          data.message ||
          "Eine Bestätigungs-E-Mail wurde an deine E-Mail-Adresse gesendet.",
      });
    } catch (err) {
      setDeleteMsg({
        kind: "error",
        text: err?.response?.data?.message || "Anfrage fehlgeschlagen.",
      });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Layout>
      <section className="konto-page">
        <div className="konto-shell">
          <header className="konto-header">
            <div>
              <h1>
                Mein <em>Konto</em>
              </h1>
              <p>
                Willkommen{user?.firstName ? `, ${user.firstName}` : ""}. Hier kannst du
                deine Profildaten, dein Passwort und deine Cookie-Einstellungen verwalten.
              </p>
            </div>
            <Link to="/konto/termine" className="btn-primary">
              Meine Termine
            </Link>
          </header>

          <ProfileSettings
            brand={APP_BRAND}
            passwordSection={<PasswordSettings user={user} embedded />}
          />
          <CookieSettings />

          {deleteMsg && (
            <div className={`auth-alert is-${deleteMsg.kind}`}>{deleteMsg.text}</div>
          )}

          <div className="konto-footer">
            <button
              type="button"
              className="btn-ghost konto-logout"
              onClick={() => setLogoutOpen(true)}
            >
              Abmelden
            </button>
            <button
              type="button"
              className="konto-delete"
              onClick={() => setDeleteOpen(true)}
            >
              Konto löschen
            </button>
          </div>
        </div>

        <ConfirmDialog
          open={logoutOpen}
          title="Abmelden?"
          message="Möchtest du dich wirklich abmelden?"
          confirmLabel="Abmelden"
          cancelLabel="Abbrechen"
          danger={false}
          onConfirm={() => {
            setLogoutOpen(false);
            handleLogout();
          }}
          onCancel={() => setLogoutOpen(false)}
        />
        <ConfirmDialog
          open={deleteOpen}
          title="Konto wirklich löschen?"
          message="Möchtest du dein Konto wirklich löschen? Du erhältst eine E-Mail mit einem Bestätigungslink."
          confirmLabel="Ja, löschen"
          cancelLabel="Abbrechen"
          busy={deleting}
          busyLabel="Wird gesendet…"
          onConfirm={confirmDeleteAccount}
          onCancel={() => !deleting && setDeleteOpen(false)}
        />
      </section>
    </Layout>
  );
};

export default KontoPage;
